<div class="container-fluid dp-0 main-landing-slider">
    <div class="container">
        <div class="row justify-content-end">
            <div class="col-md-5">
                <div class="col-md-12 slider-form">
                   <div class="row">
                       <p>Have a Query?  Let us help you find a solution for it.</p>
                   </div>
                    <form class="slider_form_new">
                        <div class="row form-group">
                            <label>
                                Full Name
                            </label>
                            <div class="col-md-12 form-group dp-0">
                                <input type="text" class="form-control" name="" placeholder="Your Name">
                            </div>
                        </div>
                        <div class="row form-group">
                            <label>
                                Contact Number
                            </label>
                            <div class="col-md-12 form-group dp-0">
                                <input type="number" class="form-control" name="" placeholder="Your Mobile Number">
                            </div>
                        </div>
                        <div class="row form-group">
                            <label>
                                Email Address
                            </label>
                            <div class="col-md-12 form-group dp-0">
                                <input type="email" class="form-control" name="" placeholder="Email">
                            </div>
                        </div>
                        <div class="row form-group">
                            <label>
                                Message
                            </label>
                            <div class="col-md-12 form-group dp-0">
                                <input type="text" class="form-control" name="" placeholder="Your Message">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12 form-group dp-0">
                                <input type="submit" class="btn btn-danger" name="" value="Enquiry Now">
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid main-why-propera dp-50">
    <div class="container">
        <div class="row">
            <div class="tg-promobox">
                <div class="tg-theme-heading">
                    <h1>WHY CHOOSE PROPIRA AS YOUR LOCAL PROPERTY EXPERT</h1>
                </div>
                <h3>We believe in transparency, fair deal, and best service at any cost. With our guidance, you will sell your property at a price you will not think twice for.</h3>
            </div>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4">
                        <div class="col-md-12 why-propera">
                            <h3>Pay as low as a</h3>
                            <h3 class="color-code-danger">0%</h3>
                            <h3 class="mb-25">
                                Listing fees
                            </h3>
                            <p>
                                You don't have to pay any money to sell your property.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="col-md-12 why-propera">
                            <h3>reach</h3>
                            <h3 class="color-code-danger">3x</h3>
                            <h3 class="mb-25">
                                more buyers
                            </h3>
                            <p>
                                Take advantage of the huge traffic of genuine buyers on our website.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="col-md-12 why-propera">
                            <h3>more</h3>
                            <h3 class="color-code-danger"><i class="fa fa-inr"></i></h3>
                            <h3 class="mb-25">
                                in your pocket
                            </h3>
                            <p>
                                Sell your property at the highest market value.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid bg-content-red">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 text-center">
                <div class="tg-promobox">
                <div class="tg-theme-heading">
                    <h1 style="color: #fff;">About Propira</h1>
                </div>
               
            </div>
                <p>
                    propira.com is an independent real estate portal that is established to bring together buyers, owners, tenants, agents etc. under one roof. We believe in nothing but transparency and are an active advocate of seeker's rights and owner's policies for the last 15 years or so.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid alwar-city-focus dp-50">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="col-md-12 content-slider-alwar">
                    <h3>Alwar City</h3>
                    <h4>Matsya Nagar of Mahabharata</h4>
                    <p>
                        Alwar is the new rising city of Rajasthan. Developing at a rapid pace while holding its historical heritage at a firm grip, Alwar is one of its kind.
                    </p>
                    <p>
                        Already known for Sariska Tiger Reserve, City Palace, Moosi Maharani Chhatri shrine, Bala Qila fort, and many more tourist attractions, Alwar is now becoming the city of the new India. 
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="col-md-12">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3a/City_of_Alwar_from_bala_quila.jpg" width="100%" height="250px">
                </div>
                <div class="col-md-12">
                    <ul class="list-inline alwar-slidere">
                        <li class="list-inline-item">
                            <a href="javascript:void(0)">
                                <img src="https://alwar.rajasthan.gov.in/content/dam/doitassets/Alwer/Photos/Alwar%20Junction1.jpg" height="50">
                            </a>
                        </li> 
                        <li class="list-inline-item">
                            <a href="javascript:void(0)">
                                <img src="https://dd0w3jaz1pep7.cloudfront.net/assets/images/tourism/city/Alwar/alwar-4fcd3fcce44d78692f22db6f.jpg" height="50">
                            </a>
                        </li>
                         <li class="list-inline-item">
                            <a href="javascript:void(0)">
                                <img src="https://dd0w3jaz1pep7.cloudfront.net/assets/images/tourism/city/Alwar/alwar-4fcd3fcce44d78692f22db6f.jpg" height="50">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cta-section pad-tb">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="cta-heading">
              <p>Request a Free Consultation!</p>
            </div>
          </div>
          <div class="col-lg-4 text-right"> <a href="#form" class="cta"> Enquire Now</a> </div>
        </div>
      </div>
    </div>


<section class="reviews-section pad-tb light-grauy" id="review">
    <div class="container">
         <div class="tg-promobox">
            <div class="tg-theme-heading">
                <h1>Our Client Reviews</h1>
            </div>
            <h3>No service is good until the client finds it best.</h3>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="reviews-block mt45">
                    <div class="reviews-card">
                        <img src="assets/images/sanjay_testimonal_listforsale.png" alt="review" />
                        <h4>Sanjay</h4>
                        <span><i class="fa fa-quote-left"></i></span>
                        <p>I wanted to sell my old house while moving to another city. That's when I first heard about Propira. They made everything so easy for me. I sold my house at a fair price within two weeks of listing my property.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="reviews-block mt45">
                    <div class="reviews-card">
                        <img src="assets/images/srishti_testimonail_listforsale.png" alt="review" />
                        <h4>Srishti</h4>
                        <span><i class="fa fa-quote-left"></i></span>
                        <p>I was recommended by my relative to try Propira. I had no idea how real estate works, so I was worried about listing my property for rent. After talking to them, I was much relieved that they will guide me at every step. Now, I am receiving my rent on time and know much about real estate.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="reviews-block mt45">
                    <div class="reviews-card">
                        <img src="assets/images/arun_testimonial_listforsale.png" alt="review" />
                        <h4>Arun </h4>
                        <span><i class="fa fa-quote-left"></i></span>
                        <p>Propira is one of the best real estate advisors I have come across. While selling my old property and purchasing the new one within the city, they never gave me a chance to question their guidance and service.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="enquire-form pad-tb" id="contact">
      <div class="container">
        <div class="row dfac">
          <div class="col-lg-8 cta-text">
            <div class="cta-heading-2">
              <img src="assets/landing/header.png" alt="text" class="img-fluid">
              <h2>Sell your property at the best price</h2>
              <p>Receive the real value of your property without any hassle. Because we do the tough work for you.</p>
              <a href="tel:+000000000" class="cta learnmore">Call Now</a>
            </div>
          </div>
          <div class="col-lg-4 pl0" id="form">
            <div class="form-block">
              <div class="form-header">
                <h2><span>Contact Form</span></h2>
                <p>Sample Flat is Ready for You</p>
              </div>
              <form action="php/mailer.php" method="post" name="feedback-form" novalidate="novalidate">
                <div class="fieldsets">  <input type="text" placeholder="Full Name" name="name"></div>
                <div class="fieldsets"><input type="email" placeholder="Email Address" name="email"> </div>
                <div class="fieldsets"><input type="number" placeholder="Contact Number" name="phone"> </div>
                <div class="fieldsets"><textarea placeholder="Message" name="message"></textarea></div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck" name="example1" checked="checked">
                  <label class="custom-control-label" for="customCheck">I agree to the <a href="javascript:void(0)">Terms &amp; Conditions</a> of Business Name.</label>
                </div>
                <div class="fieldsets"> <button type="submit" name="submit">Submit</button> </div>
                <p class="trm"><i class="fas fa-lock"></i>We hate spam, and we respect your privacy.</p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>